<div class="overflow-visible table-reusable-root" (click)="closeAllActionMenus()">
  <div class="border border-slate300 rounded-lg">
    <div
      class="overflow-x-auto overflow-y-visible table-reusable-scroll"
      >
      <table class="w-full min-w-[860px] table-fixed text-sm text-slate800 table-reusable-table">
        <thead class="bg-base">
          <tr>
            @for (
              column of columns; track trackByColumn($index,
              column); let first = $first; let last = $last) {
              <th
                scope="col"
                class="border-b border-slate300 px-4 py-3 text-left text-xs font-semibold tracking-wide text-slate900"
                [class.px-2]="column.key === 'actions'"
                [class.text-center]="column.key === 'selection'"
                [class.table-action-col]="column.key === 'actions'"
                [class.text-center]="column.key === 'actions'"
                [class.cursor-pointer]="column.sortable"
                [class.select-none]="column.sortable"
                [class.rounded-tl-lg]="first"
                [class.rounded-tr-lg]="last"
                [ngClass]="column.headerClassName"
                (click)="toggleSort(column)"
                >
                @if (column.key === 'selection') {
                  <div (click)="$event.stopPropagation()" class="flex items-center justify-center">
                    <app-reusable-checkbox
                      [ngModel]="selectAllChecked"
                      [disabled]="selectAllDisabled"
                      (ngModelChange)="onToggleSelectAll($event)"
                    ></app-reusable-checkbox>
                  </div>
                } @else if (column.headerTemplate) {
                  <div (click)="$event.stopPropagation()">
                    <ng-container
                      *ngTemplateOutlet="column.headerTemplate; context: { column: column }"
                    ></ng-container>
                  </div>
                } @else {
                  <div
                    class="inline-flex w-full items-center gap-1"
                    [class.justify-center]="column.key === 'actions'"
                    >
                    <span>{{ column.label }}</span>
                    @if (column.sortable) {
                      @let sortIndicator = getSortIndicator(column);
                      <span
                        class="inline-flex h-[13px] w-[7px] items-center justify-center"
                        aria-hidden="true"
                        >
                        <svg
                          width="7"
                          height="13"
                          viewBox="0 0 7 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          >
                          <path
                            d="M3.14926 0.934436C3.34392 0.657271 3.6566 0.657271 3.85126 0.934436L6.13177 4.18143C6.45024 4.63489 6.22795 5.41801 5.78076 5.41801H1.21976C0.772565 5.41801 0.550276 4.63489 0.868753 4.18143L3.14926 0.934436Z"
                            [attr.fill]="sortIndicator === 'asc' ? '#0F172A' : '#64748B'"
                            />
                          <path
                            d="M3.14926 11.7785C3.34392 12.0557 3.6566 12.0557 3.85126 11.7785L6.13177 8.5315C6.45024 8.07804 6.22795 7.29492 5.78076 7.29492H1.21976C0.772565 7.29492 0.550276 8.07804 0.868753 8.5315L3.14926 11.7785Z"
                            [attr.fill]="sortIndicator === 'desc' ? '#0F172A' : '#64748B'"
                            />
                        </svg>
                      </span>
                    }
                  </div>
                }
              </th>
            }
          </tr>
        </thead>

        <tbody>
          @if (loading) {
            @for (_ of skeletonRows; track _; let isLastSkeletonRow = $last) {
              <tr>
                @for (column of columns; track column) {
                  <td
                    class="px-4 py-3"
                    [class.border-b]="!isLastSkeletonRow"
                    [class.border-slate300]="!isLastSkeletonRow"
                    >
                    <div class="table-skeleton h-4 w-full rounded-md"></div>
                  </td>
                }
              </tr>
            }
          } @else if (paginatedRows.length === 0) {
            <tr>
              <td
                [attr.colspan]="columns.length"
                class="px-4 py-8 text-center text-sm font-medium text-slate500"
                >
                {{ emptyStateMessage }}
              </td>
            </tr>
          } @else {
            @for (
              row of paginatedRows; track trackByRow(rowIndex,
              row); let rowIndex = $index; let isLastRow = $last) {
              <tr
                class="group bg-white"
                >
                @for (
                  column of columns; track trackByColumn($index,
                  column); let first = $first; let last = $last) {
                  <td
                    class="px-4 py-3 transition-colors duration-150 group-hover:bg-indigo50 border-b border-slate300 w-12"
                    [class.px-2]="column.key === 'actions'"
                    [class.text-center]="column.key === 'selection'"
                    [class.table-action-col]="column.key === 'actions'"
                    [class.text-center]="column.key === 'actions'"
                    [class.border-b]="!isLastRow"
                    [class.border-slate300]="!isLastRow"
                    [class.rounded-bl-lg]="isLastRow && first"
                    [class.rounded-br-lg]="isLastRow && last"
                    [ngClass]="column.className"
                    >
                    @if (column.template) {
                      <ng-container
                  *ngTemplateOutlet="
                    column.template;
                    context: {
                      $implicit: row,
                      row: row,
                      column: column,
                      value: getCellValue(row, column),
                      rowIndex: rowIndex,
                    }
                  "
                    ></ng-container>
                  } @else if (column.key === 'selection') {
                    <div
                      class="inline-flex items-center justify-center"
                      (click)="$event.stopPropagation()"
                      >
                      <app-reusable-checkbox
                        [ngModel]="isRowSelected(row)"
                        (click)="$event.stopPropagation()"
                        (ngModelChange)="onToggleRowSelection(row, $event)"
                      ></app-reusable-checkbox>
                    </div>
                  } @else {
                    @switch (column.type ?? 'text') {
                      @case ('avatar') {
                        <div class="flex items-center gap-3">
                          @if (getAvatarImage(row, column)) {
                            <img
                              [src]="getAvatarImage(row, column)"
                              [alt]="getAvatarName(row, column)"
                              class="table-avatar-image"
                              loading="lazy"
                              />
                          } @else {
                            <div class="table-avatar-initials">
                              {{ getAvatarInitials(row, column) }}
                            </div>
                          }
                          <div class="min-w-0">
                            <p class="flex items-center gap-1 truncate font-semibold text-blue800">
                              @if (shouldShowAvatarStatusDot(column)) {
                                <span
                                  class="h-2 w-2 shrink-0 rounded-full"
                                  [class.bg-green600]="isAvatarActive(row, column)"
                                  [class.bg-red600]="!isAvatarActive(row, column)"
                                ></span>
                              }
                              @if (isAvatarNameClickable(column)) {
                                <button
                                  type="button"
                                  class="truncate cursor-pointer text-indigo600 text-xs font-medium hover:underline"
                                  (click)="onAvatarNameClick($event, row, column)"
                                >{{ getAvatarName(row, column) }}</button>
                              } @else {
                                <span class="truncate text-indigo600 text-xs font-medium">{{
                                  getAvatarName(row, column)
                                }}</span>
                              }
                            </p>
                            @if (getAvatarSecondaryText(row, column)) {
                              <p class="truncate text-xs text-slate800">
                                {{ getAvatarSecondaryText(row, column) }}
                              </p>
                            }
                          </div>
                        </div>
                      }
                      @case ('status') {
                        @let statusMeta = getStatus(row, column);
                        <span
                          class="inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold"
                          [ngClass]="[statusMeta.borderClass, statusMeta.bgClass, statusMeta.textClass]"
                          >
                          <span class="h-2 w-2 rounded-full" [ngClass]="statusMeta.dotClass"></span>
                          <span class="truncate">{{ statusMeta.label }}</span>
                        </span>
                      }
                      @case ('badge') {
                        <app-badge-reusable
                          [text]="getBadgeText(row, column)"
                          [variant]="getBadgeVariant(row, column)"
                          [size]="getBadgeSize(column)"
                          [bordered]="getBadgeBordered(column)"
                          [flat]="getBadgeFlat(column)"
                          [dot]="getBadgeDot(column)"
                        ></app-badge-reusable>
                      }
                      @case ('actions') {
                        @if (getActionMode(column) === 'inline') {
                          <div class="flex w-full items-center justify-start gap-1">
                            @for (slot of getInlineActionSlots(row, column); track slot.action) {
                              @if (!slot.visible) {
                                <span class="inline-flex h-8 w-6" aria-hidden="true"></span>
                              } @else if (slot.action === 'button') {
                                @let btnConfig = getActionButtonConfig(slot.action, row, column);
                                <app-button-reusable
                                  [variant]="btnConfig.variant ?? 'primary'"
                                  [appearance]="btnConfig.appearance ?? 'filled'"
                                  [size]="btnConfig.size ?? 'sm'"
                                  [disabled]="btnConfig.disabled ?? getActionDisabled(slot.action, row, column)"
                                  [hasIcon]="!!btnConfig.icon"
                                  [icon]="btnConfig.icon ?? null"
                                  [iconPosition]="(btnConfig.iconPosition ?? 'left')"
                                  [iconUseCurrentColor]="true"
                                  (clicked)="emitAction(slot.action, row, column)"
                                  class="flex items-center"
                                >
                                  {{ btnConfig.label }}
                                </app-button-reusable>
                              } @else {
                                <div class="inline-block" [appTooltip]="getActionTooltip(slot.action, row, column)">
                                  <button
                                    type="button"
                                    class="inline-flex h-8 w-6 items-center justify-start text-slate500 transition hover:border-blue400 hover:text-blue800 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:text-slate500 cursor-pointer"
                                    [disabled]="getActionDisabled(slot.action, row, column)"
                                    [attr.aria-label]="slot.action"
                                    (click)="emitAction(slot.action, row, column)"
                                    >
                                    @switch (slot.action) {
                                      @case ('view') {
                                        <svg
                                          width="15"
                                          height="12"
                                          viewBox="0 0 18 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          >
                                          <path
                                            d="M2.25725 7.90232C2.4953 8.29621 2.36895 8.8085 1.97506 9.04654C1.58116 9.28459 1.06888 9.15824 0.830832 8.76435C0.492418 8.20437 0.262814 7.72181 0.127803 7.41031C-0.0655207 6.96426 -0.0374703 6.46207 0.198047 6.0415C0.557434 5.39973 1.46532 3.91611 2.86451 2.58307C4.26049 1.25308 6.22475 0 8.67817 0C11.1316 0 13.0958 1.25308 14.4918 2.58307C15.891 3.91611 16.7989 5.39973 17.1583 6.0415C17.3938 6.46207 17.4219 6.96426 17.2285 7.4103C17.0935 7.72181 16.8639 8.20437 16.5255 8.76435C16.2875 9.15824 15.7752 9.28459 15.3813 9.04654C14.9874 8.8085 14.861 8.29621 15.0991 7.90232C15.3713 7.45192 15.5601 7.06241 15.6747 6.80369C15.3366 6.20778 14.5358 4.92693 13.3422 3.78975C12.1093 2.61513 10.5365 1.66667 8.67817 1.66667C6.81987 1.66667 5.24705 2.61513 4.01415 3.78975C2.82055 4.92693 2.01975 6.20778 1.68163 6.80369C1.79619 7.06241 1.98507 7.45192 2.25725 7.90232Z"
                                            fill="#475569"
                                            />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M8.67817 2.91667C6.37698 2.91667 4.5115 4.78215 4.5115 7.08333C4.5115 9.38452 6.37698 11.25 8.67817 11.25C10.9794 11.25 12.8448 9.38452 12.8448 7.08333C12.8448 4.78215 10.9794 2.91667 8.67817 2.91667ZM6.17817 7.08333C6.17817 5.70262 7.29746 4.58333 8.67817 4.58333C10.0589 4.58333 11.1782 5.70262 11.1782 7.08333C11.1782 8.46405 10.0589 9.58333 8.67817 9.58333C7.29746 9.58333 6.17817 8.46405 6.17817 7.08333Z"
                                            fill="#475569"
                                            />
                                        </svg>
                                      }
                                      @case ('edit') {
                                        <svg
                                          width="15"
                                          height="17"
                                          viewBox="0 0 17 17"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M15.4967 0.841618C14.3746 -0.280539 12.5552 -0.28054 11.433 0.841618L4.32846 7.94617C3.81848 8.45616 3.48765 9.1178 3.38566 9.83179L3.17978 11.2729C3.02264 12.3729 3.96545 13.3157 5.0654 13.1585L6.50654 12.9527C7.22052 12.8507 7.88216 12.5199 8.39215 12.0099L15.4967 4.90531C16.6189 3.78315 16.6189 1.96377 15.4967 0.841618ZM12.7861 1.87539C13.2558 1.55516 13.9015 1.60341 14.3182 2.02013C14.7349 2.43685 14.7832 3.0825 14.4629 3.55223L12.7861 1.87539ZM11.5927 3.03899L13.2993 4.74565L7.21364 10.8314C6.95865 11.0863 6.62783 11.2518 6.27083 11.3028L4.82969 11.5086L5.03557 10.0675C5.08657 9.7105 5.25198 9.37968 5.50698 9.12468L11.5927 3.03899Z"
                                            fill="#475569"
                                            />
                                          <path
                                            d="M3.33333 0.0832954C1.49239 0.0832954 0 1.57568 0 3.41663V13.4166C0 15.2576 1.49238 16.75 3.33333 16.75H13.3333C15.1743 16.75 16.6667 15.2576 16.6667 13.4166V8.41663C16.6667 7.95639 16.2936 7.5833 15.8333 7.5833C15.3731 7.5833 15 7.95639 15 8.41663V13.4166C15 14.3371 14.2538 15.0833 13.3333 15.0833H3.33333C2.41286 15.0833 1.66667 14.3371 1.66667 13.4166V3.41663C1.66667 2.49615 2.41286 1.74996 3.33333 1.74996H5.57018C6.03041 1.74996 6.40351 1.37687 6.40351 0.916629C6.40351 0.456391 6.03041 0.0832954 5.57018 0.0832954H3.33333Z"
                                            fill="#475569"
                                            />
                                        </svg>
                                      }
                                      @case ('delete') {
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 16 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          >
                                          <path
                                            d="M6.3321 1.16602C6.05499 1.16602 5.80678 1.33743 5.70864 1.59658L5.55558 2.00077C5.22746 1.96798 4.92514 1.93526 4.68042 1.90778C4.49748 1.88724 4.34709 1.86967 4.24263 1.85726L4.12213 1.8428L4.08121 1.8378C3.71581 1.79256 3.3824 2.05202 3.33715 2.41742C3.29191 2.78282 3.55144 3.11571 3.91684 3.16096L3.96136 3.16641L4.08535 3.18129C4.19225 3.19399 4.34549 3.21189 4.53164 3.23279C4.90362 3.27455 5.40848 3.32847 5.93818 3.37681C6.6527 3.44202 7.43591 3.49935 7.99877 3.49935C8.56162 3.49935 9.34484 3.44202 10.0594 3.37681C10.5891 3.32847 11.0939 3.27455 11.4659 3.23279C11.652 3.21189 11.8053 3.19399 11.9122 3.18129L12.0362 3.16641L12.0806 3.16097C12.446 3.11572 12.7056 2.78282 12.6604 2.41742C12.6151 2.05202 12.2822 1.79249 11.9168 1.83773L11.8754 1.8428L11.7549 1.85726C11.6504 1.86967 11.5001 1.88724 11.3171 1.90778C11.0724 1.93526 10.7701 1.96798 10.442 2.00077L10.2889 1.59658C10.1908 1.33743 9.94254 1.16602 9.66543 1.16602H6.3321Z"
                                            fill="#475569"
                                          />
                                          <path
                                            d="M7.3321 7.83268C7.3321 7.46449 7.03362 7.16602 6.66543 7.16602C6.29724 7.16602 5.99877 7.46449 5.99877 7.83268V11.166C5.99877 11.5342 6.29724 11.8327 6.66543 11.8327C7.03362 11.8327 7.3321 11.5342 7.3321 11.166V7.83268Z"
                                            fill="#475569"
                                          />
                                          <path
                                            d="M9.3321 7.16602C9.70029 7.16602 9.99877 7.46449 9.99877 7.83268V11.166C9.99877 11.5342 9.70029 11.8327 9.3321 11.8327C8.96391 11.8327 8.66543 11.5342 8.66543 11.166V7.83268C8.66543 7.46449 8.96391 7.16602 9.3321 7.16602Z"
                                            fill="#475569"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M12.6052 5.36639C12.6656 4.52054 11.9364 3.84244 11.1076 3.93821C10.2596 4.03622 8.95099 4.16602 7.99877 4.16602C7.04654 4.16602 5.73793 4.03622 4.8899 3.93821C4.06115 3.84244 3.33192 4.52054 3.39233 5.36639L3.96349 13.3626C4.00678 13.9687 4.45827 14.4812 5.07786 14.5744C5.74227 14.6743 6.96139 14.8339 7.99954 14.8327C9.02492 14.8315 10.249 14.6726 10.9163 14.5736C11.537 14.4815 11.9908 13.9687 12.0342 13.3607L12.6052 5.36639ZM11.2607 5.26273C11.263 5.26246 11.2648 5.26262 11.2648 5.26262L11.2665 5.26302C11.268 5.26354 11.2704 5.26475 11.2727 5.26693C11.2742 5.26837 11.2753 5.27013 11.2753 5.27013L11.2753 5.27139L10.7049 13.257C10.0444 13.3546 8.91245 13.4983 7.998 13.4993C7.07363 13.5004 5.94868 13.3566 5.29278 13.2584L4.72228 5.27139L4.72223 5.27013C4.72223 5.27013 4.72336 5.26837 4.72488 5.26693C4.72718 5.26475 4.72951 5.26354 4.73099 5.26302L4.73275 5.26262C4.73275 5.26262 4.73452 5.26246 4.73683 5.26273C5.58636 5.36091 6.9624 5.49935 7.99877 5.49935C9.03514 5.49935 10.4112 5.36091 11.2607 5.26273Z"
                                            fill="#475569"
                                          />
                                        </svg>
                                      }
                                      @case ('active') {
                                        <span class="px-2 text-xs font-semibold text-green600">Active</span>
                                      }
                                      @case ('inactive') {
                                        <span class="px-2 text-xs font-semibold text-red600">Inactive</span>
                                      }
                                    }
                                  </button>
                                </div>
                              }
                            }
                          </div>
                        } @else {
                          <div
                            class="relative inline-flex w-full justify-center"
                            [ngClass]="{ 'z-[1200]': isMenuOpen(row, rowIndex, column) }"
                            >
                            <button
                              type="button"
                              class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate300 bg-white text-slate900 transition hover:shadow-custom hover:text-blue800 cursor-pointer"
                              aria-label="Open actions"
                              (click)="toggleActionMenu($event, row, rowIndex, column)"
                              >
                              <span class="text-xl leading-none">⋮</span>
                            </button>
                          </div>
                        }
                      }
                      @default {
                        <span
                          class="table-cell-ellipsis font-medium text-xs"
                          [ngClass]="column.textClassName || 'text-slate800'"
                          [appTooltip]="getCellText(row, column)"
                          [tooltipOnlyWhenOverflow]="true"
                          >{{ getCellValue(row, column) }}</span
                          >
                        }
                      }
                    }
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    <div
      class="flex flex-col gap-3 bg-white rounded-lg px-4 py-4 sm:flex-row sm:items-center sm:justify-between table-pagination"
      >
      <div class="flex flex-wrap items-center gap-3 text-sm text-slate600 table-pagination-meta">
        @if (pageSummaryMode === 'default') {
          @if (showPageSizeSelector) {
            <label for="page-size" class="whitespace-nowrap">Rows per page</label>

            <div class="relative">
              <select
                id="page-size"
                class="rounded-md border border-slate300 bg-white pl-2 pr-6 py-1 text-sm outline-none appearance-none"
                [value]="pageSize"
                (change)="onPageSizeChange($event)"
                >
                @for (size of pageSizeOptions; track size) {
                  <option [value]="size">{{ size }}</option>
                }
              </select>

              <svg
                class="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                stroke-width="2"
                >
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          }

          <span class="whitespace-nowrap">
            {{ getCurrentRangeStart() }}
            -
            {{ getCurrentRangeEnd() }}
            of {{ totalItems }}
          </span>
        } @else {
          <div class="flex flex-wrap items-center gap-5">
            <span class="whitespace-nowrap text-[14px] font-semibold text-slate900">
              {{ getCurrentRangeStart() }} to {{ getCurrentRangeEnd() }}
              <span class="font-medium text-slate500">items of {{ totalItems }}</span>
            </span>

            @if (showViewAllLink) {
              <button
                type="button"
                class="inline-flex items-center gap-2 text-[14px] font-semibold text-slate900 transition hover:text-indigo600"
                (click)="onViewAll()"
                >
                <span>{{ viewAllLabel }}</span>
                <svg
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <path
                    d="M1 1L6 6L1 11"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    />
                </svg>
              </button>
            }
          </div>
        }
      </div>

      <div class="flex items-center gap-3 sm:gap-4 table-pagination-nav">
        <button
          type="button"
          class="inline-flex items-center justify-center cursor-pointer transition hover:bg-slate100 disabled:cursor-not-allowed disabled:opacity-40"
          [disabled]="currentPage <= 1"
          (click)="previousPage()"
          aria-label="Previous page"
          >
          <svg
            width="8"
            height="13"
            viewBox="0 0 8 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M0.234766 5.82897C-0.0769531 6.14069 -0.0769531 6.64692 0.234766 6.95864L5.02277 11.7466C5.33449 12.0584 5.84072 12.0584 6.15244 11.7466C6.46415 11.4349 6.46415 10.9287 6.15244 10.617L1.92802 6.39256L6.14994 2.16815C6.46166 1.85643 6.46166 1.3502 6.14994 1.03848C5.83822 0.726758 5.33199 0.726758 5.02027 1.03848L0.232272 5.82648L0.234766 5.82897Z"
              fill="#64748B"
              />
          </svg>
        </button>

        @for (page of visiblePageNumbers; track page) {
          <button
            type="button"
            class="inline-flex items-center justify-center cursor-pointer rounded-sm px-2 text-sm font-semibold transition table-page-btn"
            [class.border]="page === currentPage"
            [class.border-indigo600]="page === currentPage"
            [class.text-indigo700]="page === currentPage"
            [class.bg-white]="page === currentPage"
            [class.text-slate600]="page !== currentPage"
            [class.hover:text-slate900]="page !== currentPage"
            (click)="goToPage(page)"
            >
            {{ page }}
          </button>
        }

        <button
          type="button"
          class="inline-flex items-center justify-center cursor-pointer rounded-lg transition hover:bg-slate100 disabled:cursor-not-allowed disabled:opacity-40"
          [disabled]="currentPage >= totalPages"
          (click)="nextPage()"
          aria-label="Next page"
          >
          <svg
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M6.15146 5.02428C6.46318 5.336 6.46318 5.84223 6.15146 6.15395L1.36346 10.942C1.05174 11.2537 0.545508 11.2537 0.233789 10.942C-0.0779297 10.6302 -0.0779297 10.124 0.233789 9.81228L4.4582 5.58787L0.236283 1.36346C-0.075436 1.05174 -0.075436 0.545508 0.236283 0.233789C0.548002 -0.0779297 1.05423 -0.0779297 1.36595 0.233789L6.15395 5.02179L6.15146 5.02428Z"
              fill="#64748B"
              />
          </svg>
        </button>
      </div>
    </div>
  </div>

  @if (openMenuKey && openMenuRow && openMenuColumn) {
    <div
      class="absolute min-w-28 rounded-xl border border-slate300 bg-white p-2 shadow-lg"
      [style.top.px]="openMenuPosition?.top"
      [style.left.px]="openMenuPosition?.left"
      (click)="$event.stopPropagation()"
      >
      @for (tableAction of getRowActions(openMenuRow, openMenuColumn); track tableAction) {
        <button
          type="button"
          class="block w-full rounded-lg px-3 py-2 text-left text-xs font-medium text-slate800 transition hover:bg-indigo50 cursor-pointer"
          [class.text-green600]="tableAction === 'active'"
          [class.text-red600]="tableAction === 'inactive'"
          [class.text-slate800]="tableAction !== 'active' && tableAction !== 'inactive'"
          (click)="emitAction(tableAction, openMenuRow, openMenuColumn)"
          >
          {{ getActionLabel(tableAction, openMenuRow, openMenuColumn) }}
        </button>
      }
    </div>
  }
</div>
